module.exports = __webpack_public_path__ + "img/card-basic-influencer.889b9779.png";